import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { INVOICING_PERIOD_TRANSLATION_KEYS, isInvoicingPeriodInUse } from '../../constants/invoice';
import { InvoicingPeriod } from '../../interface/parameters';
import { Button, Heading, Paragraph } from '../Ant';
import NoData from '../dashboard/noData';
import { ReceiptEmpty } from '../icons';
import { PeriodDivider, PeriodSummary, PeriodTypeChip } from './preliminaryInvoiceCreation.styled';

interface PreliminaryInvoicePeriodicalFormProps {
  periodType: InvoicingPeriod | null | undefined;
  invoicingPeriod: string;
  onConfirm: () => void;
}

const PeriodLabel = ({ children }: { children: string }) => (
  <Paragraph $fontsize="12px" $weight={400} $color="title" $lineheight="18px">
    {children}
  </Paragraph>
);

const PreliminaryInvoicePeriodicalForm = ({
  periodType,
  invoicingPeriod,
  onConfirm,
}: PreliminaryInvoicePeriodicalFormProps) => {
  const { t } = useTranslation();

  if (!isInvoicingPeriodInUse(periodType)) {
    return (
      <Flex justify="center" align="center" className="h-full" role="status" aria-live="polite">
        <NoData header={t('matter:noInvoicingPeriod')} icon={<ReceiptEmpty />} />
      </Flex>
    );
  }

  return (
    <Flex vertical gap="var(--spacing-gutter)">
      <PeriodSummary
        vertical
        gap="var(--spacing-gutter)"
        data-testid="preliminary-invoice-period-summary"
      >
        <Flex justify="space-between" align="center">
          <PeriodLabel>{t('matter:periodType')}</PeriodLabel>
          <PeriodTypeChip
            data-testid="preliminary-invoice-period-type"
            justify="center"
            align="center"
            className="fw-500"
          >
            {t(INVOICING_PERIOD_TRANSLATION_KEYS[periodType])}
          </PeriodTypeChip>
        </Flex>
        <PeriodDivider />
        <Flex vertical gap={5}>
          <PeriodLabel>{t('matter:period')}</PeriodLabel>
          <Heading
            data-testid="preliminary-invoice-period"
            level={6}
            $fontsize="18px"
            $weight={600}
            $color="title"
            $lineheight="28px"
          >
            {invoicingPeriod}
          </Heading>
        </Flex>
      </PeriodSummary>
      <Button
        data-testid="create-preliminary-invoice-periodical-confirm"
        type="primary"
        size="large"
        block
        onClick={onConfirm}
      >
        {t('matter:createPreliminaryInvoice')}
      </Button>
    </Flex>
  );
};

export default PreliminaryInvoicePeriodicalForm;
